import { useEffect } from 'react';

import { useTheme } from './useTheme';

/* Shared setup for the long-form project write-ups (`/projects/spok`,
 * `/projects/tello`, `/projects/hri`, `/projects/pokemon`), which are typeset
 * with LaTeX.css rather
 * than with the portfolio's own stylesheet.
 *
 * LaTeX.css restyles bare element selectors, so it is loaded as a <link> on
 * mount and dropped again on unmount rather than bundled — otherwise it would
 * apply to the portfolio pages too.
 *
 * Returns the site-wide theme handle so the document can render its own
 * light/dark toggle. */
export const usePaperDocument = (title) => {
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${process.env.PUBLIC_URL || ''}/latex-css/style.css`;
    document.head.appendChild(link);
    return () => link.remove();
  }, []);

  /* LaTeX.css takes its dark palette from a `latex-dark` class; mirror the
   * site-wide data-theme onto it. */
  useEffect(() => {
    document.body.classList.toggle('latex-dark', theme === 'dark');
    return () => document.body.classList.remove('latex-dark');
  }, [theme]);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    window.scrollTo(0, 0);
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return { theme, toggleTheme };
};

export default usePaperDocument;
